<!-- based on: https://jsfiddle.net/robertkern/oovb8ym7/ -->

<template lang="html">
  <div class="kd-form__flipswitch">
    <input
      class="kd-form__flipswitch-cb sr-only"
      type="checkbox"
      :id="_uid"
      :value="val"
      v-model="checked"
      @change="onChange"
      @click="onClick"
    />

    <label class="kd-form__flipswitch-label" aria-hidden="true" :for="_uid">
      <div class="kd-form__flipswitch-inner"></div>
      <div class="kd-form__flipswitch-switch"></div></label>
  </div>
</template>

<script>
  export default {
    props: ['val', 'value'],

    data () {
      return {
        checkedProxy: false
      }
    },

    computed: {
      checked: {
        get() {
          return this.value
        },

        set(val) {
          this.checkedProxy = val
        }
      }
    },

    methods: {
      onChange(e) {
        this.$emit('input', this.checkedProxy, e)
      },

      onClick(e) {
        this.$emit('click', this.checkedProxy, e)
      }
    }
  }
</script>
